import { supabase } from '../lib/supabase';

export const ACTION_TYPES = {
  USER_CREATED: 'User Creation',
  ROLE_CHANGED: 'Role Change',
  PM_TOGGLED: 'PM Toggle',
  INVITATION_SENT: 'Invitation Sent',
  USER_DEACTIVATED: 'User Deactivated',
  USER_REACTIVATED: 'User Reactivated',
  USER_DELETED: 'User Deleted',
};

export const insertAuditLog = async ({ actionType, affectedUserId, affectedUserEmail, beforeValue, afterValue, description, metadata }) => {
  try {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) return;

    const { error } = await supabase?.from('audit_logs')?.insert({
      action_type: actionType,
      performed_by: user?.id,
      affected_user_id: affectedUserId || null,
      affected_user_email: affectedUserEmail || null,
      before_value: beforeValue || null,
      after_value: afterValue || null,
      description: description || null,
      metadata: metadata || {},
    });

    if (error) console.error('Audit log insert error:', error?.message);
  } catch (err) {
    console.error('Audit log service error:', err?.message);
  }
};

export const fetchAuditLogs = async ({ dateFrom, dateTo, actionTypes, adminId, affectedUserSearch, page = 1, pageSize = 50 } = {}) => {
  try {
    let query = supabase?.from('audit_logs')?.select(`
        *,
        performer:user_profiles!audit_logs_performed_by_fkey(full_name, email),
        affected:user_profiles!audit_logs_affected_user_id_fkey(full_name, email)
      `, { count: 'exact' })?.order('created_at', { ascending: false });

    if (dateFrom) query = query?.gte('created_at', dateFrom);
    if (dateTo) {
      const endDate = new Date(dateTo);
      endDate?.setHours(23, 59, 59, 999);
      query = query?.lte('created_at', endDate?.toISOString());
    }
    if (actionTypes && actionTypes?.length > 0) query = query?.in('action_type', actionTypes);
    if (adminId) query = query?.eq('performed_by', adminId);
    if (affectedUserSearch) query = query?.ilike('affected_user_email', `%${affectedUserSearch}%`);

    const from = (page - 1) * pageSize;
    const to = from + pageSize - 1;
    query = query?.range(from, to);

    const { data, error, count } = await query;
    if (error) throw error;
    return { data: data || [], count: count || 0 };
  } catch (err) {
    console.error('Fetch audit logs error:', err?.message);
    return { data: [], count: 0 };
  }
};
